import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerUpdateOrderChangePriceRationaleGql } from '../../WorkOrderChangeQueries';

export const useUpdateOrderChangePriceRationale = () => {
    const dispatch = useDispatch();

    const [resetUpdateData] = useResetStoreData({ requestId: 'uerUpdateOrderChangePriceRationale' });

    const [
        uerUpdateOrderChangePriceData,
        uerUpdateOrderChangePriceRationaleStatus,
        ,
        updateWorkOrderChangePriceRationale,
    ] = useRequest({
        requestId: 'uerUpdateOrderChangePriceRationale',
        query: uerUpdateOrderChangePriceRationaleGql,
        withEffect: false,
    });

    const updateWorkOrderChangePriceRationaleHandler = useCallback(
        (rationale: string, workOrderChangePriceId: number, workOrderPriceId: number) => {
            dispatch(
                updateWorkOrderChangePriceRationale({
                    workOrderPriceId,
                    workOrderChangePriceId,
                    input: {
                        rationale,
                    },
                }),
            );
        },
        [updateWorkOrderChangePriceRationale, dispatch],
    );

    useEffect(
        () => () => {
            resetUpdateData(undefined);
        },
        [resetUpdateData],
    );

    return useMemo(
        () => ({
            uerUpdateOrderChangePriceRationaleStatus,
            updateWorkOrderChangePriceRationaleHandler,
            uerUpdateOrderChangePriceData,
        }),
        [
            updateWorkOrderChangePriceRationaleHandler,
            uerUpdateOrderChangePriceRationaleStatus,
            uerUpdateOrderChangePriceData,
        ],
    );
};
